module.exports = __webpack_public_path__ + "img/logo.a9aa245f.png";